























import { Component, Vue, Watch } from "vue-property-decorator";
import WorkflowBuilder from "./WorkflowBuilder.vue";
import workflow_toolbar from "./workflow_toolbar.vue";
import agent_list from "./AgentList.vue";

import { ia_agents_store, ia_agent } from "@/shared/classes/ia_agents_store";
import { workflowDataType } from "./workflowDataType";
import {
  workflow_storage,
  workflow_marketplace_item,
} from "@/shared/services/workflow_storage";
import { MessageService } from "@/shared/services/message-service";
import { RouterNames } from "@/router/routernames";

@Component({
  components: {
    workflow_builder: WorkflowBuilder,
    workflow_toolbar,
    agent_list,
  },
})
export default class workflow_panel extends Vue {
  created(){
    
  }
  // Marketplace (agentes)
  get marketplaceAgents(): ia_agent[] {
    return ia_agents_store.list();
  }

  // Estado principal
  currentWorkflow: workflowDataType = {
    id: "",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    name: "",
    nodes: [],
    connections: [],
  };

  mounted() {
    if (this.$route.params && this.$route.params.id) {
      var workflow = workflow_storage.byId(this.$route.params.id as string);
      if (workflow) {
        this.currentWorkflow = workflow;
      } else {
        this.initializeWorkflow();
      }
    } else {
      this.$router.push({ name: RouterNames.workflows });
    }
  }

  // === Gestión de workflows ===
  initializeWorkflow() {
    this.currentWorkflow = workflow_storage.new();
  }

  createNewWorkflow() {
    if (
      this.currentWorkflow.name &&
      this.currentWorkflow.name.trim() &&
      this.hasUnsavedChanges()
    ) {
      if (
        confirm("¿Deseas guardar el workflow actual antes de crear uno nuevo?")
      ) {
        this.saveCurrentWorkflow();
      }
    }
    this.initializeWorkflow();
    MessageService.toast("Nuevo workflow creado", MessageService.TypeInfo);
  }

  saveCurrentWorkflow() {
    if (!this.currentWorkflow.name || !this.currentWorkflow.name.trim()) {
      MessageService.toast(
        "Por favor, asigna un nombre al workflow",
        MessageService.TypeWarning
      );
      return;
    }
    workflow_storage.save(this.currentWorkflow);
    MessageService.toast(
      "Workflow guardado correctamente",
      MessageService.TypeSuccess
    );
  }

  duplicateWorkflow() {
    if (!this.currentWorkflow.name || !this.currentWorkflow.name.trim()) {
      MessageService.toast(
        "No hay workflow para duplicar",
        MessageService.TypeWarning
      );
      return;
    }
    // Guardamos (para garantizar persistencia del actual) y luego duplicamos la versión guardada
    var saved = workflow_storage.save(this.currentWorkflow);
    workflow_storage.duplicate(saved as workflow_marketplace_item);
    MessageService.toast(
      "Workflow duplicado correctamente",
      MessageService.TypeSuccess
    );
  }

  onSelectWorkflow(payload: workflowDataType) {
    this.currentWorkflow = {
      name: payload.name,
      id: payload.id,
      createdAt: payload.createdAt,
      updatedAt: payload.updatedAt,
      nodes: payload.nodes
        ? payload.nodes.map(function(n) {
            return { ...n };
          })
        : [],
      connections: payload.connections
        ? payload.connections.map(function(c) {
            return { ...c };
          })
        : [],
    };
  }

  // === Utilidades ===
  hasUnsavedChanges(): boolean {
    return (
      (this.currentWorkflow.nodes && this.currentWorkflow.nodes.length > 0) ||
      (this.currentWorkflow.connections &&
        this.currentWorkflow.connections.length > 0)
    );
  }

  addAgentToWorkflow(agent: ia_agent) {
    // Evita duplicados por id
    var existe = false;
    for (var i = 0; i < this.currentWorkflow.nodes.length; i++) {
      if (this.currentWorkflow.nodes[i].id === agent.id) {
        existe = true;
        break;
      }
    }
    if (existe) return;

    this.currentWorkflow.nodes.push({
      id: agent.id,
      x: 100 + Math.random() * 300,
      y: 100 + Math.random() * 200,
      w: 220,
      h: 80,
      title: agent.name,
    });
  }
  @Watch("currentWorkflow")
  CurrentWork() {
    console.log(this.currentWorkflow);
  }
}
